
import FichaPorTamanho from "./FichaPorTamanho";

/** Aba Ficha Tecnica de um SABOR de pizza: a ficha padrao do sistema, com uma
 *  quantidade por tamanho em cada linha. Massa, molho, queijo e caixa entram
 *  aqui como ingredientes normais do sabor — no meio a meio cada sabor entra
 *  com 1/N de tudo (0,5 massa + 0,5 massa = 1 massa). */
export default function PizzaFichaTab({
  sizes, pizzaRecipes, setPizzaRecipes, ingredients, Combobox, getIngredientUnit, getFractionText, onCreateNew, precoDe,
}) {
  if (!sizes?.length) {
    return (
      <div className="rounded-2xl border-2 border-dashed p-8 text-center text-sm text-muted-foreground">
        Cadastre os tamanhos da pizza em <strong>Personalização Pizzas</strong> antes de montar a ficha técnica.
      </div>
    );
  }
  return (
    <div className="space-y-4">
      {/* Sem texto explicando o meio a meio: pedido do dono (09/09/2026). A regra
          (cada sabor entra com 1/N) fica no motor e no changelog. */}
      <FichaPorTamanho sizes={sizes} porTamanho={pizzaRecipes} onChange={setPizzaRecipes} ingredients={ingredients}
        Combobox={Combobox} getIngredientUnit={getIngredientUnit} getFractionText={getFractionText}
        onCreateNew={onCreateNew} precoDe={precoDe} />
    </div>
  );
}
